class KontaktThemen extends HTMLElement {
  connectedCallback() {
    this.initDetailsClickHandler();
  }

  initDetailsClickHandler() {
    this.detailsElements.forEach((item) => {
      item.addEventListener("click", (event) => this.handleClickOnDetails(event.target));
    });
  }

  handleClickOnDetails(target) {
    const targetedDetails = target.closest("details");
    if (!targetedDetails.hasAttribute("open")) {
      // close all details
      for (const item of this.openDetailsElements) {
        // keep open only details clicked
        if (targetedDetails != item) {
          item.removeAttribute("open");
        }
      }
    }
  }

  get detailsElements() {
    return Array.from(this.querySelectorAll("details"));
  }

  get openDetailsElements() {
    return Array.from(this.querySelectorAll("details[open]"));
  }
}

if (!customElements.get("kontakt-themen")) {
  customElements.define("kontakt-themen", KontaktThemen);
}
